export default __webpack_public_path__ + "img/martins.0add4b73.jpeg";